export default "__VITE_ASSET__lJGRij1n__"